const PageContent = () => {
    return (
        <div className="main-banner header-text" id="top">
            <div className="Modern-Slider">
                <div className="item item-1">
                    <div className="img-fill">
                        <div className="text-content">
                            <h6>join our tech community</h6>
                            <h4>Knowledge Sharing <br />& Collaborative Learning</h4>
                            <p>Creative Lab ISI Ariana is an IT club devoted to sharing knowledge, learning how to collaborate in groups, and building tomorrow's tech leaders. We organize workshops, competitions, and community service projects.</p>
                            <a href="/JoinUs" className="filled-button">join us</a>
                        </div>
                    </div> 
                </div>
                <div className="item item-2">
                    <div className="img-fill">
                        <div className="text-content">
                            <h6>expand your skills</h6>
                            <h4>Training Workshops <br />& Tech Events</h4>
                            <p>From Flutter & Mobile Development to competitive programming, we offer hands-on training sessions led by industry experts. Participate in events like Play4Hope Cup and "Land It!" to challenge yourself and grow.</p>
                            <a href="/OurEvents" className="filled-button">our events</a>
                        </div>
                    </div>
                </div>
                <div className="item item-3">
                    <div className="img-fill">
                        <div className="text-content">
                            <h6>make a difference</h6> 
                            <h4>Community Impact <br />& Social Responsibility</h4>
                            <p>Beyond tech skills, we believe in giving back. Our community service initiatives, like organizing iftar for children at Dar Maram, show how technology professionals can make a positive social impact.</p>
                            <a href="/AboutUs" className="filled-button">learn more</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PageContent;